export const headerMenuStyles = {
	menuButton: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end'
	},
	avatar: {
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'background.paper',
		width: 28,
		height: 28
	},
	avatarIcon: {
		width: 17
	},
	logoutIcon: {
		width: 18,
		height: 18
	},
	menu: {
		'& .MuiButtonBase-root .MuiListItemText-root span': {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			gap: 1
		}
	},
	menuList: {
		minWidth: 150
	}
};
